import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from 'react';
import { useSyncExternalStore } from './useSyncExternalStore.mjs';
import { parseMutationArgs, MutationObserver, notifyManager } from '@tanstack/query-core';
import { useQueryClient } from './QueryClientProvider.mjs';
import { shouldThrowError } from './utils.mjs';

function useMutation(arg1, arg2, arg3) {
  var options = parseMutationArgs(arg1, arg2, arg3);
  var queryClient = useQueryClient({
    context: options.context
  });

  var _React$useState = React.useState(function () {
    return new MutationObserver(queryClient, options);
  }),
      _React$useState2 = _slicedToArray(_React$useState, 1),
      observer = _React$useState2[0];

  React.useEffect(function () {
    observer.setOptions(options);
  }, [observer, options]);
  var result = useSyncExternalStore(React.useCallback(function (onStoreChange) {
    return observer.subscribe(notifyManager.batchCalls(onStoreChange));
  }, [observer]), function () {
    return observer.getCurrentResult();
  }, function () {
    return observer.getCurrentResult();
  });
  var mutate = React.useCallback(function (variables, mutateOptions) {
    observer.mutate(variables, mutateOptions).catch(noop);
  }, [observer]);

  if (result.error && shouldThrowError(observer.options.useErrorBoundary, [result.error])) {
    throw result.error;
  }

  return _objectSpread(_objectSpread({}, result), {}, {
    mutate: mutate,
    mutateAsync: result.mutate
  });
} // eslint-disable-next-line @typescript-eslint/no-empty-function


function noop() {}

export { useMutation }; //# sourceMappingURL=useMutation.mjs.map